
const ExamMultipleReportLayout = r => require(['@/v3/modules/report/views/multiple/report/layout'], r)
const ExamMultipleReportClassBasic = r => require(['@/v3/modules/report/views/multiple/report/class/basic'], r)
const ExamMultipleReportClassComment = r => require(['@/v3/modules/report/views/multiple/report/class/comment'], r)
const ExamMultipleReportClassAbility = r => require(['@/v3/modules/report/views/multiple/report/class/ability'], r)
const ExamMultipleReportClassTranscript = r => require(['@/v3/modules/report/views/multiple/report/class/transcript'], r)
const ExamMultipleReportGradeBasic = r => require(['@/v3/modules/report/views/multiple/report/grade/basic'], r)
const ExamMultipleReportGradeComment = r => require(['@/v3/modules/report/views/multiple/report/grade/comment'], r)
const ExamMultipleReportGradeAbility = r => require(['@/v3/modules/report/views/multiple/report/grade/ability'], r)
const ExamMultipleReportGradeTranscript = r => require(['@/v3/modules/report/views/multiple/report/grade/transcript'], r)

export default {
  path: '/exam/multiple/report/',
  component: ExamMultipleReportLayout,
  redirect: '/exam/multiple/report/grade/basic/:id',
  children: [
    {
      path: '/exam/multiple/report/class/basic/:id',
      meta: { auth: ['Multiple-Subject-Report', 'Region-Multiple-Subject-Report', 'Exam-Report', 'Region-Exam-Report'] },
      component: ExamMultipleReportClassBasic,
      name: 'exam-multiple-class-basic'
    },
    {
      path: '/exam/multiple/report/class/comment/:id',
      meta: { auth: ['Multiple-Subject-Report', 'Region-Multiple-Subject-Report', 'Exam-Report', 'Region-Exam-Report'] },
      component: ExamMultipleReportClassComment,
      name: 'exam-multiple-class-comment'
    },
    {
      path: '/exam/multiple/report/class/ability/:id',
      meta: { auth: ['Multiple-Subject-Report', 'Region-Multiple-Subject-Report', 'Exam-Report', 'Region-Exam-Report'] },
      component: ExamMultipleReportClassAbility,
      name: 'exam-multiple-class-ability'
    },
    {
      path: '/exam/multiple/report/class/transcript/:id',
      meta: { auth: ['Multiple-Subject-Report', 'Region-Multiple-Subject-Report', 'Exam-Report', 'Region-Exam-Report'] },
      component: ExamMultipleReportClassTranscript,
      name: 'exam-multiple-class-transcript'
    },
    {
      path: '/exam/multiple/report/grade/basic/:id',
      meta: { auth: ['Exam-Multiple-Report-Grade', 'Multiple-Subject-Report', 'Region-Multiple-Subject-Report', 'Exam-Report', 'Region-Exam-Report'] },
      component: ExamMultipleReportGradeBasic,
      name: 'exam-multiple-grade-basic'
    },
    {
      path: '/exam/multiple/report/grade/comment/:id',
      meta: { auth: ['Exam-Multiple-Report-Grade', 'Multiple-Subject-Report', 'Region-Multiple-Subject-Report', 'Exam-Report', 'Region-Exam-Report'] },
      component: ExamMultipleReportGradeComment,
      name: 'examine-multiple-grade-comment'
    },
    {
      path: '/exam/multiple/report/grade/ability/:id',
      meta: { auth: ['Exam-Multiple-Report-Grade', 'Multiple-Subject-Report', 'Region-Multiple-Subject-Report', 'Exam-Report', 'Region-Exam-Report'] },
      component: ExamMultipleReportGradeAbility,
      name: 'examine-multiple-grade-ability'
    },
    {
      path: '/exam/multiple/report/grade/transcript/:id',
      meta: { auth: ['Exam-Multiple-Report-Grade', 'Multiple-Subject-Report', 'Region-Multiple-Subject-Report', 'Exam-Report', 'Region-Exam-Report'] },
      component: ExamMultipleReportGradeTranscript,
      name: 'examine-multiple-grade-transcript'
    }
  ]
}
